import React, { useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../../../components/MaterialTypography";
import { useLocation, useNavigate } from "react-router-dom";
import { BsFillPersonVcardFill } from "react-icons/bs";
import Grid from "@mui/material/Grid2";
import MaterialBox from "../../../../../components/MaterialBox";
import MaterialSelect from "../../../../../components/MasterSelect";
import { newcustomerState, newCustomerStateMange } from "./newCustomerState";
import MaterialInput from "../../../../../components/MaterialInput";
import MaterialButton from "../../../../../components/MaterialButton";
import LocationPicker from "./LocationPicker";
import CameraCapture from "./CameraCapture";
import {
  newcustomerCategoryOption,
  newcreateCustomer,
  uploadNewCustomerList,
  getNewCustomerById,
} from "./NewCustomerData";
import { useLoading } from "../../../../../context/LodingContext";
import BASEURL from "../../../../../pages/Utils/Baseurl";
import Swal from "sweetalert2";
import request from "graphql-request";
import { useMutation } from "@apollo/client";
import { useAuthData } from "../../../../context/loginContext/LoginContextProvider";
import URL from "../../../../../pages/Utils/url";
import { productCodeOption } from "../../../salesOrder/salesOrderData/salesOrderData";

const NewCustomerForm = () => {
  const [newCustomerData, dispatch] = useReducer(
    newCustomerStateMange,
    newcustomerState
  );
  const location = useLocation();
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const formType = location?.state?.type;
  const formValue = location?.state?.data;
  const [customerPhoto, setCustomerPhoto] = useState(null);
  const [customerimageFile, setCustomerImageFile] = useState(null);
  const [inputDisble, setInputDisble] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const [UpdateBrand] = useMutation(uploadNewCustomerList);
  const { authenticated, setAuthenticated, userId, setUserID } = useAuthData();
  const [createNewCustomer, { loading, error }] =
    useMutation(newcreateCustomer);
  const [designationData, setDesignationData] = useState({
    latitude: "",
    latitudeStatus: "unchecked",
    longitude: "",
    longitudeStatus: "unchecked",
  });
  const params = useLocation();
  const id = params.search.slice(1);
  const pathname = params?.pathname?.slice(13);
  useEffect(() => {
    if (id) {
      fetchNewCustomerById();
    }
  }, [id]);

  useEffect(() => {
    if (pathname === "view-new-customer") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);
  const handleLocationSelect = (location) => {
    setDesignationData({
      ...designationData,
      latitude: location.lat,
      longitude: location.lng,
      latitudeStatus: "success",
      longitudeStatus: "success",
    });
    setMapOpen(false);
  };
  const getCurrentLocation = () => {
    setMapOpen(true);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      newCustomerData.customerCategoryStatus === "success" &&
      newCustomerData.customerCodeStatus === "success" &&
      newCustomerData.customerNameStatus === "success" &&
      newCustomerData.customeraddressStatus === "success" &&
      newCustomerData.emailStatus === "success" &&
      newCustomerData.numberStatus === "success" &&
      newCustomerData.dateStatus === "success" &&
      // newCustomerData.latitudeStatus === "success" &&
      // newCustomerData.longitudeStatus === "success" &&
      newCustomerData.priceCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const fetchNewCustomerById = async () => {
    try {
      const response = await request(BASEURL, getNewCustomerById, {
        id: id.slice(3),
      });

      const customer = response?.customerDetails?.data?.[0];

      if (!customer) return;

      dispatch({
        value: {
          value: customer.customerCategory,
          label: customer.customerCategory,
        },
        name: "customerCategory",
      });
      dispatch({ value: customer.customerCode, name: "customerCode" });
      dispatch({ value: customer.customerName, name: "customerName" });
      dispatch({ value: customer.startDate, name: "date" });
      dispatch({
        value: { value: customer.priceCode, label: customer.priceCode },
        name: "priceCode",
      });
      dispatch({ value: customer.phoneNo, name: "number" });
      dispatch({ value: customer.email, name: "email" });
      dispatch({ value: customer.address, name: "customeraddress" });

      // Also set coordinates if available
      if (customer.locationLat && customer.locationLng) {
        setDesignationData({
          latitude: customer.locationLat,
          longitude: customer.locationLng,
          latitudeStatus: "success",
          longitudeStatus: "success",
        });

        dispatch({ value: customer.locationLat, name: "latitude" });
        dispatch({ value: customer.locationLng, name: "longitude" });
      }

      // Set image if available
      if (customer.customerPlace) {
        setCustomerPhoto(`${URL}media/${customer.customerPlace}`);
      }
    } catch (error) {
      console.error("Unable to fetch data", error);
    }
  };

  const handleAddNewCustomer = async () => {
    const data = {
      user: userId,
      customerCategory: newCustomerData?.customerCategory?.label,
      customerCode: newCustomerData?.customerCode,
      customerName: newCustomerData?.customerName,
      address: newCustomerData?.customeraddress,
      startDate: newCustomerData?.date || "",
      priceCode: newCustomerData?.priceCode?.label,
      phoneNo: newCustomerData?.number,
      email: newCustomerData?.email,
      locationLat: designationData?.latitude,
      locationLng: designationData?.longitude,
      customerPlace: customerimageFile,
    };

    setCirleLoading(true);

    try {
      const res = await createNewCustomer({
        variables: {
          input: data,
        },
        context: { hasUpload: true },
      });
      const success = res?.data.createCustomerDetails?.success;
      const message = res?.data.createCustomerDetails?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/newcustomer");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };
  const handleUpdateBrand = async () => {
    setCirleLoading(true);

    const data = {
      id: id.slice(3),
      user: userId,
      customerCategory: newCustomerData?.customerCategory?.label,
      customerCode: newCustomerData?.customerCode,
      customerName: newCustomerData?.customerName,
      address: newCustomerData?.customeraddress,
      startDate: newCustomerData?.date,
      priceCode: newCustomerData?.priceCode?.label,
      phoneNo: newCustomerData?.number,
      email: newCustomerData?.email,
      locationLat: designationData?.latitude,
      locationLng: designationData?.longitude,
      customerPlace:
        customerimageFile && customerimageFile.name ? customerimageFile : null,
    };

    try {
      const response = await UpdateBrand({
        variables: {
          input: data,
        },
        context: { hasUpload: true },
      });

      const res = response?.data?.updateCustomerDetails?.success;
      const message = response?.data?.updateCustomerDetails?.message;

      if (res) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/newcustomer");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
      Swal.fire({
        position: "top",
        icon: "error",
        title: "Network Error",
        showConfirmButton: true,
      });
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {pathname == "add-new-customer"
                    ? "Add New Customer Details"
                    : pathname == "edit-new-customer"
                    ? "Edit New Customer Details"
                    : "View New Customer Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Category <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="customerCategory"
                  value={newCustomerData?.customerCategory}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={newcustomerCategoryOption?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: s?.name })}
                  isClearable
                  error={
                    newCustomerData.customerCategoryStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    newCustomerData.customerCategoryStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={newCustomerData?.customerCode}
                  name="customerCode"
                  placeholder="Enter Customer Code"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "customerCode" })
                  }
                  error={
                    newCustomerData.customerCodeStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    newCustomerData.customerCodeStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="customerName"
                  value={newCustomerData?.customerName}
                  placeholder="Enter Customer Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "customerName" })
                  }
                  error={
                    newCustomerData.customerNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    newCustomerData.customerNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Customer Address <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={4}
                  name="customeraddress"
                  value={newCustomerData?.customeraddress}
                  placeholder="Enter Customer Address"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "customeraddress",
                    })
                  }
                  error={
                    newCustomerData.customeraddressStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    newCustomerData.customeraddressStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Business Started Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  disabled={inputDisble}
                  name="date"
                  type="date"
                  value={newCustomerData.date}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "date" })
                  }
                  error={newCustomerData.dateStatus === "error" ? true : false}
                  success={
                    newCustomerData.dateStatus === "success" ? true : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Price Code
                    <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="priceCode"
                  value={newCustomerData?.priceCode}
                  customStyles={{ optionPadding: 20 }}
                  isDisabled={inputDisble}
                  options={productCodeOption?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e) => dispatch({ value: e, name: "priceCode" })}
                  error={
                    newCustomerData.priceCodeStatus === "error" ? true : false
                  }
                  success={
                    newCustomerData.priceCodeStatus === "success" ? true : false
                  }
                  isClearable
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Contact Number <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="number"
                  placeholder="Enter Contact Number"
                  value={newCustomerData?.number}
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "number" })
                  }
                  error={
                    newCustomerData.numberStatus === "error" ? true : false
                  }
                  success={
                    newCustomerData.numberStatus === "success" ? true : false
                  }
                />
                {newCustomerData.numberStatus === "error" && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
                  >
                    {
                      // "Please enter a contact number between 8 to 15 digits."
                      "Please enter a contact number should accept only 8 digits."
                    }
                  </p>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Email ID <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="email"
                  placeholder="Enter Email ID"
                  value={newCustomerData?.email}
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "email" })
                  }
                  error={newCustomerData.emailStatus === "error" ? true : false}
                  success={
                    newCustomerData.emailStatus === "success" ? true : false
                  }
                />
                {newCustomerData.emailStatus === "error" && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
                  >
                    {"Invalid Email ID. Please enter a valid Email ID."}
                  </p>
                )}
              </Grid>
              <Grid item xs={5} sm={3}>
                <Box display="flex" alignItems="center" mt={2}>
                  <MaterialButton
                    variant="contained"
                    onClick={getCurrentLocation}
                    sx={{ mt: 2 }}
                  >
                    Get Coordinates
                  </MaterialButton>
                  <span style={{ color: "red" }}>*</span>

                  <Box ml={2} lineHeight={0} mt={2}>
                    <MaterialTypography variant="caption" display="block">
                      <span style={{ fontWeight: "bold" }}>Longitude:</span>{" "}
                      {designationData.longitude}
                    </MaterialTypography>
                    <MaterialTypography variant="caption" display="block">
                      <span style={{ fontWeight: "bold" }}>Latitude:</span>{" "}
                      {designationData.latitude}
                    </MaterialTypography>
                  </Box>
                </Box>

                <LocationPicker
                  open={mapOpen}
                  onClose={() => setMapOpen(false)}
                  onSelectLocation={handleLocationSelect}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Customer Place Image
                </MaterialTypography>

                {/* Show CameraCapture only for add-new-customer */}
                {pathname.includes("add-new-customer") && (
                  <CameraCapture
                    onCapture={(photo) => {
                      setCustomerPhoto(photo);
                    }}
                    setCustomerImageFile={(file) => setCustomerImageFile(file)}
                  />
                )}

                {/* Show image preview if photo exists */}
                {customerPhoto && (
                  <Box mt={2}>
                    <MaterialTypography variant="caption" fontWeight="bold">
                      Captured Image Preview:
                    </MaterialTypography>
                    <img
                      src={
                        typeof customerPhoto === "string" &&
                        !customerPhoto.startsWith("data:")
                          ? customerPhoto
                          : customerPhoto
                      }
                      alt="Customer"
                      style={{ maxWidth: "300px", marginTop: "10px" }}
                      onError={(e) => {
                        console.error("Image load error:", customerPhoto);
                        e.target.style.display = "none";
                      }}
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/newcustomer")}
            >
              Cancel
            </MaterialButton>
            {pathname != "view-new-customer" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={
                  formType == "add" ? handleAddNewCustomer : handleUpdateBrand
                }
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default NewCustomerForm;
